var $ = require('jquery');
var NotificationBase = require('../NotificationBase');
/**
 *
 */
(function() {
    var GuidanceNotification = NotificationBase.extend({
        /**
         * Default sticky for GuidanceNotification
         */
        stickyDefault: 0,
        /**
         * Default severity for GuidanceNotification
         */
        severityDefault: 1,
        /**
         * Default category for GuidanceNotification
         */
        categoryDefault: 3,
        /**
         * parameters for determining default operation,
         * if null or false, they are ignored
         */
        iconCls: 'ui-icon-compass',
        /**
         * overwrite default severity css class with the one from severity-medium-low
         * @returns string
         */
        getSeverityClass: function() {
            return this.severityClass[4];
        },
        getCssClassSuffix: function() {
            return 'guidance';
        },
        /**
         * this method must be implemented by all Notifications
         */
        getContent: function() {
            var msg = jimdoData.messages.guidance.notification;
            var $content = $(
                '<div class="title">' + msg.title + '</div>' +
                '<div class="description">' + msg.content + '</div>' +
                '<div class="button-bar cp-style">' +
                    '<button class="small blue-primary">' + msg.start + '</button>' +
                '</div>'
            );

            $content.find('button')
                .button()
                .bind('click', function() {
                    //TODO: This seems not needed because of globalAction
                    //diy.editor.guidance.start();
                });

            return $content;
        },

        globalAction: function() {
            diy.editor.guidance.start();
        },

        getName: function() {
            return 'GuidanceNotification';
        }
    });

    module.exports = GuidanceNotification;
}());



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/notification/Notifications/GuidanceNotification.js
 ** module id = 657
 ** module chunks = 0
 **/